<template>
  <b-col
    cols="12"
  >
    <b-table
      class="table-bordered border"
      :fields="fields"
      :items="items"
      show-empty
      hover
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>


      <template #cell(goods)="props">
        <div v-if="props && props.item && props.item.goods">
          <b-badge class="mb-25" v-for="(item, index) in props.item.goods"
          :key="`${index}title`">
            {{ item }}
          </b-badge>
        </div>
      </template>



      <template #cell(from_storage)="props">
        <div v-if="props && props.item && props.item.from_storage">
          {{props.item.from_storage.title}}
        </div>
      </template>


      <template #cell(to_storage)="props">
        <div v-if="props && props.item && props.item.to_storage">
          {{props.item.to_storage.title}}
        </div>
      </template>


      <template #cell(status)="props">
        <b-badge v-if="props && props.item && props.item.status" :variant="props.item.status.color">
          <span>{{ props.item.status.name }}</span>
        </b-badge>
        <feather-icon
          v-if="props &&  props.item && props.item.status"
          v-b-tooltip.focus="{ variant: props.item.status.color }"
          :title="props.item.status.description"
          class="ml-25"
          icon="InfoIcon"
          size="24"
        />
      </template>



      <template #cell(actions)="data">
        <span class="d-flex">
          <b-button
            :disabled="data.item.isSaved"
            size="sm"
            class="mt-50 mb-50"
            variant="danger"
            @click="$emit('deleleRequest',data.index)"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </span>
      </template>


    </b-table>
  </b-col>
</template>

<script>
import {
  BButton,
  BCol,
  BTable,
  BBadge,
  BFormSpinbutton,
  VBTooltip,
} from 'bootstrap-vue'

export default {
  components: {
    BCol,
    BTable,
    BButton,
    BBadge,
    BFormSpinbutton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    good_return: {
      type: Object,
      default: () => ({}),
    },
    checkIsSaved: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fields: [
      {
        label: '№',
        key: 'id',
        thClass: 'text-center',
        tdClass: 'text-center',
        thClass: { width: '5%' },
      },
      {
        label: 'namee',
        key: 'goods',
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        label: 'where2',
        key: 'from_storage',
        thClass: 'text-center',
        tdClass: 'text-center',
        thStyle: { width: '20%' },
      },
      {
        label: 'where',
        key: 'to_storage',
        thClass: 'text-center',
        tdClass: 'text-center',
        thStyle: { width: '20%' },
      },
      {
        label: 'status',
        key: 'status',
        thClass: 'text-center',
        tdClass: 'text-center',
        thStyle: { width: '20%' },
      },
      // {
      //   label: 'actions',
      //   key: 'actions',
      //   thClass: 'text-center',
      //   tdClass: 'text-center',
      //   thStyle: { width: '5%' },
      // },
    ],
    items: []
  }),
  watch: {
    good_return(newValue, oldValue){
      this.items = []
      this.items.push(newValue)
    }
  },
}
</script>

<style>

</style>
